/**
 * Sites Hub — single page with tabs for site list and site health scores.
 */

import { useState } from 'react';
import { SiteList } from './SiteList';
import { SiteHealthScores } from './SiteHealthScores';

const TABS = [
  { id: 'list', label: 'Site List' },
  { id: 'health', label: 'Health Scores' },
] as const;

type TabId = typeof TABS[number]['id'];

export function SitesHub() {
  const [activeTab, setActiveTab] = useState<TabId>('list');

  return (
    <div>
      {/* Tab Bar */}
      <div className="flex gap-1 border-b border-border mb-6">
        {TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
              activeTab === tab.id
                ? 'border-baker-red text-baker-red'
                : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      {activeTab === 'list' && <SiteList />}
      {activeTab === 'health' && <SiteHealthScores />}
    </div>
  );
}
